import handleMethod from '../Utils/APIutils/handleMethod';

class CountingAPI {
  async getById(id) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/${id}` });
  }

  async listByStore(storeId, page = 1, itemsPerPage = 50) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/by-store/${storeId}?page=${page}&itemsPerPage=${itemsPerPage}` });
  }

  async listByClient(clientId, page = 1, itemsPerPage = 50) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/by-client/${clientId}?page=${page}&itemsPerPage=${itemsPerPage}` });
  }

  async getRecentByDevice(deviceId, lastHours = 24) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/device/${deviceId}/recent?lastHours=${lastHours}` });
  }

  async getByDateRange(deviceId, startDate, endDate) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/device/${deviceId}/range?startDate=${from}&endDate=${to}` });
  }

  async getAggregates(clientId, startDate, endDate, timeUnit = 'HOUR', storeId = null, deviceIds = null, storeIds = null) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const storeParam = storeId ? `&storeId=${storeId}` : '';
    const storeIdsParam = storeIds?.length ? storeIds.map(id => `&storeIds=${id}`).join('') : '';
    const deviceParam = deviceIds?.length ? deviceIds.map(id => `&deviceIds=${id}`).join('') : '';
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/aggregates/${clientId}?startDate=${from}&endDate=${to}&timeUnit=${timeUnit}${storeParam}${storeIdsParam}${deviceParam}` });
  }

  async getHourlyStatistics(storeId, startDate, endDate) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/hourly/${storeId}?startDate=${from}&endDate=${to}` });
  }

  async getTrendData(deviceId, startDate, endDate) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/trend/${deviceId}?startDate=${from}&endDate=${to}` });
  }

  async getDailySummary(clientId, startDate, endDate, storeId = null, storeIds = null, search = null, cities = null, page = null, itemsPerPage = null) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const storeParam = storeId ? `&storeId=${storeId}` : '';
    const storeIdsParam = storeIds?.length ? storeIds.map(id => `&storeIds=${id}`).join('') : '';
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    const citiesParam = cities?.length ? cities.map(c => `&cities=${encodeURIComponent(c)}`).join('') : '';
    const pageParam = page ? `&page=${page}` : '';
    const itemsPerPageParam = itemsPerPage ? `&itemsPerPage=${itemsPerPage}` : '';
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/daily-summary/${clientId}?startDate=${from}&endDate=${to}${storeParam}${storeIdsParam}${searchParam}${citiesParam}${pageParam}${itemsPerPageParam}` });
  }

  async getDwellSummary(clientId, startDate, endDate, storeIds = null, page = 1, itemsPerPage = 20, deviceIds = null) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const storeIdsParam = storeIds?.length ? storeIds.map(id => `&storeIds=${id}`).join('') : '';
    const deviceIdsParam = deviceIds?.length ? deviceIds.map(id => `&deviceIds=${id}`).join('') : '';
    const pageParam = `&page=${page}&itemsPerPage=${itemsPerPage}`;
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/dwell-summary/${clientId}?startDate=${from}&endDate=${to}${storeIdsParam}${deviceIdsParam}${pageParam}` });
  }

  async getDwellKpi(clientId, startDate, endDate, storeIds = null) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const storeIdsParam = storeIds?.length ? storeIds.map(id => `&storeIds=${id}`).join('') : '';
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/dwell-kpi/${clientId}?startDate=${from}&endDate=${to}${storeIdsParam}` });
  }

  async getGenderSummary(clientId, startDate, endDate, storeId = null) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const storeParam = storeId ? `&storeId=${storeId}` : '';
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/gender-summary/${clientId}?startDate=${from}&endDate=${to}${storeParam}` });
  }

  async getAgeSummary(clientId, startDate, endDate, storeId = null) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const storeParam = storeId ? `&storeId=${storeId}` : '';
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/countings/age-summary/${clientId}?startDate=${from}&endDate=${to}${storeParam}` });
  }
}

export const countingAPI = new CountingAPI();
